import React from 'react'
import Banner from '../components/Banner/Banner'
import CoinTable from '../components/CoinTable'

const Home = () => {
    return (
        <div>
            <Banner />
            <CoinTable />
        </div>
    )
}

export default Home
